module.exports = __webpack_public_path__ + "img/xds.83df0b86.jpg";